<template>
  <ul class="tree-view">
    <branch v-for="(item, i) in value" :key="i" :item="item" />
  </ul>
</template>

<script>
import Branch from './Branch'
export default {
  name: 'TreeView',
  components: { Branch },
  props: {
    value: { type: Array, default: () => [] }
  }
}
</script>

<style lang="scss">
  @import "../../../../scss/vars";
  .tree-view {
    ul {
      padding-left: $basic-padding * 2 + $basic-padding / 2;
    }
    li {
      min-height: unset;
    }
  }
</style>
